import { useState } from "react";
import { toast } from "sonner";
import { Copy, Share2, Printer, Check } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function ResultActions({ text, title }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    if (!text) return;
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      toast.success("Copied to clipboard");
      setTimeout(() => setCopied(false), 1500);
    } catch {
      toast.error("Couldn't copy — please copy manually");
    }
  };

  const handleShare = async () => {
    const payload = { title: title || "Fitness Calculator", text, url: window.location.href };
    if (navigator.share) {
      try { await navigator.share(payload); } catch {}
    } else {
      try {
        await navigator.clipboard.writeText(`${text}\n${window.location.href}`);
        toast.success("Result + link copied — paste to share");
      } catch {
        toast.error("Sharing not supported on this browser");
      }
    }
  };

  const handlePrint = () => window.print();

  return (
    <div className="flex flex-wrap gap-2 no-print" data-testid="result-actions">
      <Button variant="outline" size="sm" onClick={handleCopy} data-testid="btn-copy">
        {copied ? <Check className="h-4 w-4 mr-1.5" /> : <Copy className="h-4 w-4 mr-1.5" />}
        Copy
      </Button>
      <Button variant="outline" size="sm" onClick={handleShare} data-testid="btn-share">
        <Share2 className="h-4 w-4 mr-1.5" />
        Share
      </Button>
      <Button variant="outline" size="sm" onClick={handlePrint} data-testid="btn-print">
        <Printer className="h-4 w-4 mr-1.5" />
        Print / PDF
      </Button>
    </div>
  );
}
